import 'owl.carousel';

const text_Sliders = document.querySelectorAll('.bm-text-slider');

(function($){

	text_Sliders.forEach(slider => {
		const $slider = $(slider);
		const $carousel = $slider.find('.owl-carousel');

		if ( $carousel.find('.bm-text-slider__slide').length > 1 ) {
			$carousel.owlCarousel({
				loop: false,
				nav: true,
				dots: false,
				items: 1,
				singleItem: true,
				autoplay: true,
				autoplayTimeout: 5000,
				autoplayHoverPause: true,
				autoHeight: true,
			});
		} else {
			$carousel.show();
		}
	});

})(jQuery);
